<template>
  <div class="about">
    <v-card color="blue lighten-5">
      <v-card-text>
        <h3>Reminder</h3>
        The materials on Life RTL are strictly not to be copied, redistributed or shared by any means.
      </v-card-text>
    </v-card>
    <p></p>
    <h1>Videos</h1>
    <v-layout justify-center>
      <v-flex xs12 sm12>
        <v-card>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex>
                <v-card v-if="activeCard.ready">
                  <v-card-title>
                    <div>
                      <span>{{ activeCard.Event.Name }}</span>
                      <br />
                      <span class="grey--text" v-if="activeCard.Event.ScriptureReference">{{ activeCard.Event.ScriptureReference }}</span>
                      <br v-if="activeCard.Event.ScriptureReference" />
                    </div>
                  </v-card-title>
                  <video-player class="vjs-custom-skin pa-2" :options="playerOption" :playsinline="true"></video-player>
                </v-card>
                <v-list-item two-line v-for="mediaEntry in mediaEntryList" :key="mediaEntry.ID" v-on:click="loadEvent(mediaEntry.ID)">
                  <v-list-item-content>
                    <v-list-item-title>
                      <span>{{ mediaEntry.Event.Name }}</span>
                      <span v-if="mediaEntry.Event.ScriptureReference"> ({{ mediaEntry.Event.ScriptureReference }})</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>{{ mediaEntry.Event.Date }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-videojs7";
import axios from "axios";

export default {
  props: {
    id: {
      type: String,
      default: "1",
    },
  },
  name: "TempVideoList",
  components: {
    videoPlayer,
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  watch: {
    id: function (newID, oldID) {
      this.initialize();
    },
  },
  data() {
    return {
      activeCard: {
        ID: 0,
        CreatedAt: "2019-06-15T02:18:04.600131+08:00",
        EditedAt: "2019-06-15T02:18:04.600131+08:00",
        DeletedAt: "",
        Title: "",
        ThumbnailUrl: "",
        Url: "",
        DownloadUrl: "",
        Downloadable: true,
        OriginalFilename: "",
        EncryptedFilename: "",
        Date: "",
        EventID: 0,
        Event: {},
        BucketID: 0,
        Bucket: {},
        MediaType: {},
        MediaTypeID: 0,
        Author: {},
        AuthorID: 0,
        Index: 0,
        ready: false,
      },
      playerOption: {
        index: 1,
        title: "",
        autoplay: false,
        muted: false,
        inactivityTimeout: 2000,
        fluid: true,
        sources: [
          {
            type: "",
            src: "",
          },
        ],
        html5: {
          hls: {
            overrideNative: true,
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false,
        },
        playbackRates: [1, 1.25, 1.5, 1.75, 2],
        ready: false,
      },
      mediaEntryList: [],
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.EventList = [];
      axios
        .get("/api/content/author/" + this.id + "/mediatype/2/mediaentrylist")
        .then((response) => {
          this.mediaEntryList = response.data;
          this.mediaEntryList.map((x) => {
            let eventDate = new Date(x.Event.Date);
            x.Event.Date =
              eventDate.getDate() +
              " " +
              this.months[eventDate.getMonth()] +
              " " +
              eventDate.getFullYear();
          });
          this.activeCard.ready = false;
        })
        .catch(() => {});
    },
    loadEvent(mediaEntryID) {
      let activeCardList = this.mediaEntryList.filter(
        (x) => x.ID == mediaEntryID
      );
      if (activeCardList.length >= 1) {
        this.activeCard = activeCardList[0];
        this.playerOption.title = this.activeCard.Event.Name;
        this.playerOption.sources = [
          {
            type: "application/x-mpegURL",
            src: this.activeCard.Url,
          },
        ];
        this.activeCard.ready = true;
      }
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>